module.exports = __webpack_public_path__ + "static/media/1POLICY22.6e2ba569.jpg";